import { create } from 'zustand';

export const useMediaToQualifyFiltersStore = create((set, get) => ({
  // État initial
  filters: {
    selectedStatusId: null,
    selectedType: null,
    selectedTags: null,
    selectedMediaFormat: null,
    selectedOrder: null,
    selectedCategoryName: null,
    selectedDimensions: null,
    selectedSizes: null,
    selectedResolutions: null,
    selectedCreatedAt: null,
    sortBy: '-created_at',
  },

  // Actions
  setFilters: (newFilters) =>
    set({
      filters: newFilters,
    }),

  updateFilters: (partialFilters) =>
    set({
      filters: { ...get().filters, ...partialFilters },
    }),

  setFilter: (key, value) =>
    set({
      filters: { ...get().filters, [key]: value },
    }),

  removeFilter: (key) => {
    const { [key]: _, ...remainingFilters } = get().filters;
    set({ filters: remainingFilters });
  },

  clearFilters: () =>
    set({
      filters: {
        selectedStatusId: null,
        selectedType: null,
        selectedTags: null,
        selectedMediaFormat: null,
        selectedOrder: null,
        selectedCategoryName: null,
        selectedDimensions: null,
        selectedSizes: null,
        selectedResolutions: null,
        selectedCreatedAt: null,
        sortBy: '-created_at',
      },
    }),

  getFilters: () => get().filters,

  getFilter: (key) => get().filters[key],

  hasFilters: () => Object.keys(get().filters).length > 0,

  hasFilter: (key) => key in get().filters,
}));
